import { __assign } from '../_virtual/_tslib.js';
import { InMemoryCache, defaultDataIdFromObject, ApolloClient, from } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import createHttpLink from './createHttpLink.js';
import fetch from 'cross-fetch';
import reconnectAuthChange from './links/reconnectAuthChange.js';

function dealApiClient(clientOptions) {
    var ssrMode = clientOptions.ssrMode;
    var _a = createHttpLink({
        endpoint: clientOptions.endpoint,
        webSocketEndpoint: !ssrMode ? clientOptions.webSocketEndpoint : undefined,
        viewerContext: clientOptions.viewerContext,
        experimentOverrides: clientOptions.experimentOverrides,
        fetch: fetch,
        clientAwarenessName: clientOptions.clientAwarenessName,
        clientAwarenessVersion: clientOptions.clientAwarenessVersion
    }), httpLink = _a.link, reconnect = _a.reconnect;
    var relayStylePaginationTypePolicies = {};
    var _loop_1 = function (typeName, fields) {
        var fieldPolicies = {};
        fields.forEach(function (fieldName) {
            var policy = relayStylePagination();
            fieldPolicies[fieldName] = {
                keyArgs: function (args) {
                    if (!args) {
                        return undefined;
                    }
                    var keyArgs = new Set(Object.keys(args));
                    keyArgs.delete('first');
                    keyArgs.delete('after');
                    keyArgs.delete('last');
                    keyArgs.delete('before');
                    return Array.from(keyArgs);
                },
                merge: function (existing, incoming, options) {
                    if (incoming === void 0) { incoming = {}; }
                    return policy.merge(existing, incoming, options);
                },
                read: policy.read
            };
        });
        relayStylePaginationTypePolicies[typeName] = {
            fields: fieldPolicies
        };
    };
    for (var _i = 0, _b = Object.entries(clientOptions.cacheRelayStylePaginationFields); _i < _b.length; _i++) {
        var _c = _b[_i], typeName = _c[0], fields = _c[1];
        _loop_1(typeName, fields);
    }
    var cache = new InMemoryCache({
        possibleTypes: Object.assign(clientOptions.cachePossibleTypes, {
            Mergeable: clientOptions.cacheNonNormalizableTypes
        }),
        typePolicies: __assign({ Mergeable: {
                merge: true
            } }, relayStylePaginationTypePolicies),
        dataIdFromObject: function (responseObject) {
            return (defaultDataIdFromObject(responseObject) || null);
        }
    }).restore(clientOptions.initialCacheState || {});
    var apolloClient = new ApolloClient({
        link: from((clientOptions.links || []).concat([reconnectAuthChange(reconnect), httpLink])),
        cache: cache,
        connectToDevTools: !ssrMode,
        ssrMode: ssrMode,
        assumeImmutableResults: true,
        name: clientOptions.clientAwarenessName,
        version: clientOptions.clientAwarenessVersion
    });
    return {
        apolloClient: apolloClient,
        reconnect: reconnect
    };
}

export default dealApiClient;
//# sourceMappingURL=client.js.map
